module.exports = __webpack_public_path__ + "static/media/express.f2ba0cff.svg";